import ProductsHero from './components/ProductsHero';
import CategoriesGrid from './components/CategoriesGrid';
import FeaturedProducts from './components/FeaturedProducts';
import BrandsShowcase from './components/BrandsShowcase';
import ProductsCTA from './components/ProductsCTA';

export default function ProductsPage() {
  return (
    <main>
      <ProductsHero />
      <div id="categories">
        <CategoriesGrid />
      </div>
      <FeaturedProducts />
      <BrandsShowcase />
      <ProductsCTA />
    </main>
  );
}